import { AxiosError, AxiosResponse } from "axios";
import { useMutation } from '@tanstack/react-query';
import { useContext } from "react";
import { AuthContext, AuthContextProviderProps } from "../../context/AuthContext";
import Nullable from "../../types/Nullable";
import { Uporabnik } from "../../types/Uporabnik";
import client from "../../services/client";

const useAddUporabnik = (setLoggedInUserParam: ((uporabnik: Nullable<Uporabnik>) => void) | null) => {
    let { setLoggedInUser } = useContext<AuthContextProviderProps>(AuthContext);
    return useMutation<AxiosResponse, AxiosError, string>( async () => {
        try {
            return (await client.post(`uporabnik`, null));
        }
        catch (error) {
            return Promise.reject(error);
        }
    }, {
            onSuccess: (resp) => {
                if (!setLoggedInUser && setLoggedInUserParam)
                    setLoggedInUser = setLoggedInUserParam;
                setLoggedInUser!(resp.data);
            }
        }
    );
};

export default useAddUporabnik;